module.exports = __webpack_public_path__ + "source-sans-pro-v11-latin-600italic-30179d0fe14ed8bd384b2787f897eb81.bundle.woff";